import { format } from 'date-fns';
import FormTableCalculateDisplay from '../../../components/form-table-calculate/form-table-calculate.component';
import FormTableHeaderCell from '../../../components/form-table-header-cell/form-table-header-cell.component';
import FormTableInlineDelete from '../../../components/form-table-inline-delete/form-table-inline-delete.component';
import FormTableSelect from '../../../components/form-table-select/form-table-select.component';
import FormTableTextField from '../../../components/form-table-text-field/form-table-text-field.component';

export const COMPANY_INFO = {
  formTitle: "Company",
  formTitleForNew: "New Company",
  path: "/companies",
  listPage: "/companies",
}

export const COMPANY_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "company",
      fieldItems: [
        {
          label: "Company Name",
          type: "text",
          name: "companyName",
          initialFocus: false,
          validationProps: {
            required: "Company Name is required",
            minLength: {
              value: 2,
              message: "Company Name must be more than 2 letters"
            }
          }
        },
        {
          label: "Registered date",
          type: "date",
          name: "registeredDate",
          initialFocus: false,
          validationProps: {
            required: "Registered date is required"
          }
        },
        {
          label: "Remark",
          type: "textarea",
          name: "description",
          required: false,
          initialFocus: false,
          muliselect: false,
        },
        {
          label: "Enable E-Invoice Integration",
          type: "checkbox",
          name: "isEInvoiceEnabled",
          initialFocus: false
        }
      ]
    },
    // Features that cut across modules (not one module's screens).
    generalPermissionDetails: {
      sectionType: "General Access Rights",
      sectionTypeId: "generalPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "generalPermission",
      fieldItems: [
        {
          // Receipt photo / PDF on Sales, Purchase, Customer, Operating Expense, Rental and POS payments. Off by default.
          label: "Payment Attachments",
          type: "select",
          name: "paymentAttachment",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
      ]
    },
    salesPermissionDetails: {
      sectionType: "Sales Access Rights",
      sectionTypeId: "salesPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 3,
      fieldName: "salesPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Sales module.
          label: "Sales Module",
          type: "select",
          name: "salesModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Sales Orders",
          type: "select",
          name: "salesOrder",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Customers",
          type: "select",
          name: "customer",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Sales Quotes",
          type: "select",
          name: "salesQuote",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Sales Return",
          type: "select",
          name: "salesReturn",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Packing",
          type: "select",
          name: "packing",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Shipping",
          type: "select",
          name: "shipping",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Export Shipments menu, the "Foreign sale" switch on sales orders and the
          // Bill's "Export shipment" field. Off for every company until enabled here.
          label: "Export Shipments",
          type: "select",
          name: "exportShipment",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          // Customer "Documents" tab (start / expiration dates) and the red / green
          // document flag on the Sales Order's Customer field. Off until enabled here.
          label: "Customer Documents",
          type: "select",
          name: "customerDocument",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
      ]
    },
    purchasePermissionDetails: {
      sectionType: "Purchasing Access Rights",
      sectionTypeId: "purchasingPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "purchasingPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Purchasing module.
          label: "Purchasing Module",
          type: "select",
          name: "purchasingModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Purchase Orders",
          type: "select",
          name: "purchaseOrder",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Suppliers",
          type: "select",
          name: "supplier",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Purchase Return",
          type: "select",
          name: "purchaseReturn",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Import Shipments menu, the "Import" switch on purchase orders and the
          // Bill's "Import shipment" field. Off for every company until enabled here.
          label: "Import Shipments",
          type: "select",
          name: "importShipment",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
      ]
    },
    inventoryPermissionDetails: {
      sectionType: "Stock Access Rights",
      sectionTypeId: "inventoryPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 5,
      fieldName: "inventoryPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Inventory module.
          label: "Inventory Module",
          type: "select",
          name: "stockModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Products",
          type: "select",
          name: "item",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Categories",
          type: "select",
          name: "itemGroup",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Stock Tranfers",
          type: "select",
          name: "stockTransfer",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Stock Adjustment",
          type: "select",
          name: "stockAdjustment",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Stock Count",
          type: "select",
          name: "stockCount",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Batch tracking (batch number + expiry per product, per location). Off by default.
          label: "Batch Tracking",
          type: "select",
          name: "batchTracking",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Unit of Measures",
          type: "select",
          name: "unitOfMeasure",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Locations",
          type: "select",
          name: "location",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Item Taxes",
          type: "select",
          name: "itemTax",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    manufacturingPermissionDetails: {
      sectionType: "Manufacturing Access Rights",
      sectionTypeId: "manufacturingPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "manufacturingPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Manufacturing module.
          label: "Manufacturing Module",
          type: "select",
          name: "manufacturingModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Manufacturing Order",
          type: "select",
          name: "manufacturingOrder",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Bill of Materials",
          type: "select",
          name: "billOfMaterials",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Work Centers",
          type: "select",
          name: "workCenter",
          required: false,
          initialFocus: false,
          // Actual default (off for every existing tenant) is set by the
          // feature_flags row the migration inserts - this is only the
          // client-side placeholder shown before that row loads, same as
          // every other field in this section.
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    projectPermissionDetails: {
      sectionType: "Project Access Rights",
      sectionTypeId: "projectPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "projectPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Project module.
          label: "Project Module",
          type: "select",
          name: "projectModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Projects",
          type: "select",
          name: "project",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Off by default (docs/projects/DESIGN.md): tasks board, timesheets, costing, billing, reports.
          label: "Project Management",
          type: "select",
          name: "projectManagement",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        }
      ]
    },
    hrPermissionDetails: {
      sectionType: "Human Resource Access Rights",
      sectionTypeId: "hrPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 4,
      fieldName: "hrPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Human Resource module.
          label: "Human Resource Module",
          type: "select",
          name: "hrModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Employees",
          type: "select",
          name: "employee",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Attendances",
          type: "select",
          name: "attendance",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Leaves",
          type: "select",
          name: "leave",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Payrolls",
          type: "select",
          name: "payroll",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Departments",
          type: "select",
          name: "department",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Job Titles",
          type: "select",
          name: "jobTitle",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        // HR extension (docs/features/hr-payroll/DESIGN.md). Off until enabled here.
        {
          label: "Payroll Settings",
          type: "select",
          name: "payrollSettings",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Employee Loans",
          type: "select",
          name: "employeeLoan",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Employee Journey (requests, offboarding)",
          type: "select",
          name: "employeeJourney",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Employee Self-Service",
          type: "select",
          name: "selfService",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Attendance Machines & Shifts",
          type: "select",
          name: "attendanceMachine",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Overtime Requests",
          type: "select",
          name: "overtimeRequest",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Complaints & Praise",
          type: "select",
          name: "complaint",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Disciplinary Actions",
          type: "select",
          name: "disciplinaryAction",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          label: "Performance Reviews",
          type: "select",
          name: "performanceReview",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
      ]
    },
    financePermissionDetails: {
      sectionType: "Finance Access Rights",
      sectionTypeId: "financePermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "financePermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Finance module.
          label: "Finance Module",
          type: "select",
          name: "financeModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Journal Entries",
          type: "select",
          name: "journalEntry",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Charts of Accounts",
          type: "select",
          name: "chartOfAccount",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Operating Expense",
          type: "select",
          name: "operatingExpense",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Expense Type",
          type: "select",
          name: "expenseType",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
      ]
    },
    assetPermissionDetails: {
      sectionType: "Asset Access Rights",
      sectionTypeId: "assetPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "assetPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Asset module (menu, routes, settings entries).
          label: "Asset Module",
          type: "select",
          name: "assetModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Assets, Asset Categories - off for every existing tenant via the feature_flags row the migration inserts.
          label: "Assets",
          type: "select",
          name: "assetManagement",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Maintenance Orders",
          type: "select",
          name: "maintenanceOrder",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Depreciation",
          type: "select",
          name: "assetDepreciation",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Asset Report",
          type: "select",
          name: "maintenanceReport",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    rentalPermissionDetails: {
      sectionType: "Rental Access Rights",
      sectionTypeId: "rentalPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "rentalPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Rental module (menu, routes).
          label: "Rental Module",
          type: "select",
          name: "rentalModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Rental Orders, Properties, Rental Reports - off by default, same as Assets above.
          label: "Rental Orders",
          type: "select",
          name: "rental",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Properties",
          type: "select",
          name: "property",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Rental Report",
          type: "select",
          name: "rentalReport",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    crmPermissionDetails: {
      sectionType: "CRM Access Rights",
      sectionTypeId: "crmPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "crmPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole CRM module (menu, routes, settings entries,
          // Customer Overview tab, Home card). Off for every existing tenant via the migration's rows.
          label: "CRM Module",
          type: "select",
          name: "crmModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Opportunities, Opportunity Stages, Lost Reasons, Sales Teams.
          label: "Opportunities",
          type: "select",
          name: "crm",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Leads, Lead Sources.
          label: "Leads",
          type: "select",
          name: "lead",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // My Activities, activity reminder bell.
          label: "Activities",
          type: "select",
          name: "crmActivity",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "CRM Report",
          type: "select",
          name: "crmReport",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    posPermissionDetails: {
      sectionType: "Point of Sale Access Rights",
      sectionTypeId: "posPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "posPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Point of Sale module (menu, terminal, routes).
          // Off for every existing tenant via the migration's rows.
          label: "Point of Sale Module",
          type: "select",
          name: "posModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Terminal, Point of Sale Orders.
          label: "Point of Sale Terminal",
          type: "select",
          name: "pos",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Sessions",
          type: "select",
          name: "posSession",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Returns",
          type: "select",
          name: "posReturn",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Registers (Point of Sale Settings).
          label: "Registers",
          type: "select",
          name: "posRegister",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Point of Sale Report",
          type: "select",
          name: "posReport",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Restaurant mode on registers (floors, kitchen, bookings, QR ordering, recipes). Off by default.
          label: "Restaurant",
          type: "select",
          name: "restaurant",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        }
      ]
    },
    hotelPermissionDetails: {
      sectionType: "Hotel Access Rights",
      sectionTypeId: "hotelPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "hotelPermission",
      fieldItems: [
        {
          // Master switch: Disable hides the whole Hotel module (menu, routes, Settings > Hotel, Home card).
          // Off by default (docs/features/hotel/DESIGN.md).
          label: "Hotel Module",
          type: "select",
          name: "hotelModule",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Disable', value: 2 },
          url: "/featureflagoptions"
        },
        {
          // Front Desk, Reservations, Folios.
          label: "Front Desk & Reservations",
          type: "select",
          name: "hotel",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Housekeeping",
          type: "select",
          name: "hotelHousekeeping",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Hotel Report",
          type: "select",
          name: "hotelReport",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          // Point of Sale "Charge to room" for checked-in guests.
          label: "Charge to Room",
          type: "select",
          name: "hotelChargeToRoom",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    reportPermissionDetails: {
      sectionType: "Report Access Rights",
      sectionTypeId: "reportPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 2,
      fieldName: "reportPermission",
      fieldItems: [
        {
          label: "Reports",
          type: "select",
          name: "report",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
    systemPermissionDetails: {
      sectionType: "System Access Rights",
      sectionTypeId: "systemPermissionDetails",
      multiForm: false,
      expandable: true,
      addButton: true,
      breakPoint: 1,
      fieldName: "systemPermission",
      fieldItems: [
        {
          label: "Accounts",
          type: "select",
          name: "account",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Company",
          type: "select",
          name: "company",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        },
        {
          label: "Help Center",
          type: "select",
          name: "helpCenter",
          required: false,
          initialFocus: false,
          defaultValue: { label: 'Enable', value: 1 },
          url: "/featureflagoptions"
        }
      ]
    },
  },
  watchFields: []
}
